import { render, staticRenderFns } from "./BlurArea.vue?vue&type=template&id=2587a448&scoped=true&"
import script from "./BlurArea.vue?vue&type=script&lang=js&"
export * from "./BlurArea.vue?vue&type=script&lang=js&"
import style0 from "./BlurArea.vue?vue&type=style&index=0&id=2587a448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2587a448",
  null
  
)

export default component.exports